/**
 * Hook chamado UMA vez pelo app-core (`ui/modules.tsx`): liga o carregamento
 * dos dados das estações e adiciona a camada ao mapa quando ele existir.
 */
import { createElement, useEffect } from 'react';
import { useMapInstance } from '../map/mapContext';
import { createStationLayer } from './layer';
import { StationPopup } from './StationPopup';
import { startStationSync } from './sync';

export { refreshEstacoes } from './sync';

export function useStationLayers(): void {
  const map = useMapInstance((s) => s.map);

  useEffect(() => startStationSync(), []);

  useEffect(() => {
    if (!map) return;
    const { layer, dispose } = createStationLayer((dado) => createElement(StationPopup, { dado }));
    map.addLayer(layer);
    return () => {
      map.removeLayer(layer);
      dispose();
    };
  }, [map]);
}
